
const Login = () => import('@/components/Shared/Login');
const UpdatePassword = () => import('@/components/Shared/UpdatePassword');
//const Rssdi_login = () => import('@/components/Shared/Rssdi_login');
const Landing = () => import('@/components/Home/Landing');
const Pricing = () => import('@/components/Home/Pricing');
const ForgotPassword = () => import('@/components/Shared/ForgotPassword');
// import Login from '@/components/Shared/Login'
// import Landing from '@/components/Home/Landing'
// import Pricing from '@/components/Home/Pricing'
// import ForgotPassword from '@/components/Shared/ForgotPassword'

// testing
const First = () => import('@/components/Sample/First');
const Second = () => import('@/components/Sample/Second');
const Third = () => import('@/components/Sample/Third');
const Test = () => import('@/components/Sample/Test');
const NewOne = () => import('@/components/Sample/NewOne');
const Hash = () => import('@/components/Sample/Hash');
const Seo1 = () => import('@/components/Sample/seo1');
const Seo2 = () => import('@/components/Sample/seo2');
//end
const VideoPlayer = () => import('@/components/MediaPlayer/VideoPlayer');
const Player = () => import('@/components/MediaPlayer/Player');
const VideoCall = () => import('@/components/MediaPlayer/VideoCall');
const DocViewer = () => import('@/components/Document/DocViewer');
const PDFViewer = () => import('@/components/Document/PDFViewer');
const RenderPdf = () => import('@/components/Document/RenderPdf');

//PGD
const RssdiPG = () => import('@/components/PaymentGateway/RssdiPG');
const PG = () => import('@/components/PaymentGateway/PG');
const CoursePurchase = () => import('@/components/Purchase/CoursePurchase');
//Easycheck Redirect
const EasycheckRedirect = () => import('@/components/Easycheck/EasycheckRedirect');

// import First from '@/components/Sample/First'
// import Second from '@/components/Sample/Second'
// import Third from '@/components/Sample/Third'
// import Test from '@/components/Sample/Test'
// import NewOne from '@/components/Sample/NewOne'
// const Announcement = () => import('@/components/Sample/Announcement');
const routes = [
  {
    path: '/course-purchase',
    name: 'course-purchase',
    component: CoursePurchase,
  },
  {
    path: '/pg',
    name: '/pg',
    component: PG,
  },
  {
    path: '/rssdi-pg',
    name: '/rssdi-pg',
    component: RssdiPG,
  },
  {
    path: '/pdf-viewer',
    name: 'pdf-viewer',
    component: PDFViewer,
  },
  {
    path: '/pdf1',
    name: 'pdf1',
    component: RenderPdf,
  },
  {
    path: '/doc-viewer',
    name: 'doc-viewer',
    component: DocViewer,
  },
  // Video player
  {
    path: '/vplayer',
    name: 'vplayer',
    component: VideoPlayer,
  },
  {
    path: '/play',
    name: 'play',
    component: VideoCall,
  },
  //ends
  {
    path: '/player',
    name: 'player',
    component: Player,
  },
   //testing
  {
    path: '/newone',
    name: 'newone',
    component: NewOne,
  },
  // {
  //   path: '/announcement',
  //   name: 'instructor-announcement-notices',
  //   component: Announcement,
  // },
  {
    path: '/hash',
    name: 'hash',
    component: Hash,
  },
  {
    path: '/seo1',
    name: 'seo1',
    component: Seo1,
  },
  {
    path: '/seo2/:id',
    name: 'seo2',
    component: Seo2,
  },
  {
    path: '/test',
    name: 'test',
    component: Test,
  },
  {
    path: '/first',
    name: 'test-first',
    component: First,
  },
  {
    path: '/third',
    name: 'test-third',
    component: Third,
  },
  {
    path: '/second',
    name: 'test-second',
    component: Second,
  },
  //testing ends
  {
    path: '/',
    name: 'login',
    component: Login,
  },
  {
    path: '/update-password',
    name: 'update-password',
    component: UpdatePassword,
  },
  {
    path: '/login',
    name: 'login_other',
    component: Login,
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: Pricing,
  },
  {
    path: '/main-home',
    name: 'main-home',
    component: Landing,
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword,
  },
  //Easycheck Redirect
  {
    path: '/easycheck-redirect',
    name: 'easycheck-redirect',
    component: EasycheckRedirect,
  },
  
]

export default routes